<template>
  <span class="nc-badge" :class="['nc-badge--' + color, 'nc-badge--' + size]">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'NcBadge',
  props: {
    color: { type: String, default: 'primary' },
    size: { type: String, default: 'md' },
  },
};
</script>

<style scoped>
.nc-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border-radius: 6px;
  white-space: nowrap;
}
.nc-badge--sm { font-size: 11px; padding: 2px 6px; }
.nc-badge--md { font-size: 13px; padding: 3px 10px; }
.nc-badge--lg { font-size: 14px; padding: 4px 12px; }
.nc-badge--primary { background: rgba(20, 182, 154, 0.08); color: #14b69a; }
.nc-badge--success { background: rgba(20, 182, 154, 0.08); color: #14b69a; }
.nc-badge--warning { background: rgba(255, 196, 9, 0.12); color: #e08700; }
.nc-badge--danger { background: rgba(235, 68, 90, 0.08); color: #eb445a; }
.nc-badge--medium { background: rgba(146, 148, 156, 0.08); color: #92949c; }
</style>
